{
  "slug": "iq-percentiles",
  "title": "الجدول المئوي لمعدل الذكاء وشرح ذلك",
  "description": "ترجمة الدرجات المشتركة إلى رتب مئوية تقريبية.",
  "category": "إحصاءات الذكاء",
  "sections": [
    {
      "heading": "المعنى",
      "paragraphs": [
        "ترجمة الدرجات المشتركة إلى رتب مئوية تقريبية.",
        "ويتوقف التفسير على السكان، والوسيلة، والطبعة، والسنة، وأخذ العينات، واللغة، والطريقة."
      ]
    },
    {
      "heading": "1-1-1-1-1- قراءة الرسوم البيانية بعناية",
      "paragraphs": [
        "1- التحقق من التمثيلية، وعدم التيقن، والاستبعادات، وما إذا كانت القيم قد قيست أو قُدرت.",
        "وتتداخل متوسطات المجموعات تداخلا كبيرا ولا يمكن أن تحدد فردا ما."
      ]
    },
    {
      "heading": "استنتاج مسؤول",
      "paragraphs": [
        "تفضيل مجموعات البيانات الأولية الشفافة والفترات الفاصلة بينها، وتجنب الادعاءات السببية من الارتباط وحده.",
        "بالنسبة للفرد، استخدم معايير السن المناسبة والوثائق التقنية."
      ]
    }
  ],
  "related": ["what-is-the-average-iq", "how-is-iq-measured", "iq-score-ranges-explained"],
  "sources": [
    {
      "label": "منظمة التعاون والتنمية في الميدان اﻻقتصادي - بيانات ومنهجية برنامج التقييم الدولي للطﻻب",
      "url": "https://www.oecd.org/pisa/data/"
    }
  ],
  "faqs": [],
  "summary": "ترجمة الدرجات المشتركة إلى درجات مئوية تقريبية. 18 تموز/يوليه 2026."
}
